import React,{useEffect,useState}from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import CreateViewEditPickList from "./create-view-edit-picklist";
import InnerLayout from "../../../components/layouts/inner-layout";
import { warehouseGetIdAction } from "../../../redux/actions/inventory-action";
import { CreatePickList } from "../../../redux/actions/sales-action";
import LoadingSpinner from "../../../components/helper-components/loading-spinner";
import errorToast from "../../../components/helper-components/error-toast";
import { useNavigate } from "react-router-dom";
const AddPickList = () => {
  const { itemId, type } = useParams();
  const [searchParams] = useSearchParams();
  const dispatch = useDispatch();
  const itemIdArray = JSON.parse(decodeURIComponent(itemId));
  const [loading,setLoading]=useState(true);
  const [orderDetail,setOrderDetail]=useState({});
  const [warehouseId, setWarehouseId] = useState(null);
  const vendorDetails = orderDetail?.vendorDetails?.[0] || {};

  useEffect(() => {
    dispatch(warehouseGetIdAction({},onWarehouseSuccess,onWarehouseError))
  }, []);
  const onWarehouseSuccess = (res) => {
    const sottMap = itemIdArray.reduce((acc, item) => {
      if (!acc[item.sott_id]) {
        acc[item.sott_id] = { sott_id: item.sott_id, item_ids: [] };
      }
      if (item.item_id) {
        acc[item.sott_id].item_ids.push(item.item_id);
      }
      return acc;
    }, {});
    const data={
        warehouse_id: res?.data?.pos_id,
        sott_id: Object.values(sottMap),
        picker_id: null
    }
    setWarehouseId(res?.data?.pos_id ?? null);
    dispatch(CreatePickList(data,onCreatePickListSuccess,onCreatePickListError));
  };
  const navigate = useNavigate();
  const onWarehouseError = (err) => {
    errorToast(err?.data?.message);
  };
  const onCreatePickListSuccess = (data) => {
    setOrderDetail(data?.data)
    setLoading(false);
  }
  const onCreatePickListError = (err) => {
    setLoading(false);
    navigate(-1);
    errorToast(err?.data?.message);
  };
  const prefix = "pl";
  return (
    <>
        {loading ? (
          <LoadingSpinner />
        ) : (
          <InnerLayout backBtn={true} title="Add Pick List">
            <CreateViewEditPickList
                vendorDetails={[vendorDetails]}
                itemData={orderDetail?.itemData}
                payto={ vendorDetails?.[`sott_pay_to_address`]}
                shipto={vendorDetails?.[`sott_ship_to_address`]}
                pickListId={orderDetail?.pick_list_id}
                warehouseId={warehouseId}
                clickedplus={true}
                pageType='picklist'
                page='add'
                disabled={false}
            />
          </InnerLayout>
        )}
    </>
  );
};
export default AddPickList;